<template>
  <a href="https://t.me/alanverne" target="_blank">Telegram</a>
</template>

<script>
export default {
  name: "TextMe"
}
</script>

<style scoped>

</style>